module.exports = __webpack_public_path__ + "img/no-data@2x.cabefc9f.png";